export default function NotFoundPage() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-default">404</h1>
        <p className="mt-2 text-data">Page not found</p>
      </div>
    </div>
  )
}
